import { useContext } from "react";
import { MasajidContext } from "../contexts/MasajidContext";
import Header from "./Header";

function LanguageSelector() {
  const { changeLanguage } = useContext(MasajidContext);

  return (
    <div
      style={{
        position: "fixed",
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        background: "linear-gradient(180deg, #041b23 0%, #0a3545 100%)",
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        zIndex: 9999,
        padding: "20px",
      }}
    >
      <Header />

      <div
        className="card text-center"
        style={{
          width: "95%",
          maxWidth: "400px",
          background: "radial-gradient(circle, #0a3545, #041b23)",
          border: "3px solid rgb(27, 179, 200, 0.3)",
          borderRadius: 24,
          color: "#ffffff",
          boxShadow: "5px 5px 15px #021015",
          padding: "32px 24px",
        }}
      >
        <p style={{ marginBottom: 8, fontSize: "1.1rem" }}>
          Please select your preferred language.
        </p>
        <p style={{ marginBottom: 8, fontSize: "0.9rem", opacity: 0.8 }}>
          You can change this later.
        </p>

        <p style={{ marginBottom: 8, marginTop: 24, fontSize: "1.1rem" }} lang="ur">
          براہ کرم اپنی پسندیدہ زبان منتخب کریں۔
        </p>
        <p style={{ marginBottom: 0, fontSize: "0.9rem", opacity: 0.8 }} lang="ur">
          آپ اسے بعد میں تبدیل کر سکتے ہیں۔
        </p>

        <div
          style={{
            display: "flex",
            flexDirection: "column",
            gap: "12px",
            marginTop: "32px",
          }}
        >
          <button
            onClick={() => changeLanguage("english")}
            style={{
              padding: "14px 24px",
              fontSize: "1.1rem",
              fontWeight: "bold",
              background: "linear-gradient(135deg, #1bb3c8 0%, #0a3545 100%)",
              border: "2px solid rgb(27, 179, 200, 0.5)",
              borderRadius: 16,
              color: "#ffffff",
              cursor: "pointer",
            }}
          >
            English
          </button>
          <button
            onClick={() => changeLanguage("urdu")}
            style={{
              padding: "14px 24px",
              fontSize: "1.1rem",
              fontWeight: "bold",
              background: "linear-gradient(135deg, #1bb3c8 0%, #0a3545 100%)",
              border: "2px solid rgb(27, 179, 200, 0.5)",
              borderRadius: 16,
              color: "#ffffff",
              cursor: "pointer",
            }}
            lang="ur"
          >
            اردو
          </button>
        </div>
      </div>
    </div>
  );
}

export default LanguageSelector;
